"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorNotFound = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const faTimes_1 = require("@fortawesome/free-solid-svg-icons/faTimes");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const GenericError_1 = require("../GenericError");
function ErrorNotFound() {
    const { pathname } = react_router_dom_1.useLocation();
    react_1.useEffect(() => {
        console.error('Not found:', pathname);
    }, [pathname]);
    return (jsx_runtime_1.jsxs(GenericError_1.GenericError, Object.assign({ title: "Sorry!", icon: faTimes_1.faTimes }, { children: [jsx_runtime_1.jsx("p", { children: "We did our best to find what you were looking for, but failed." }, void 0),
            jsx_runtime_1.jsxs("p", { children: ["If this was not a mistake, please let us know at", ' ', jsx_runtime_1.jsx("a", Object.assign({ href: "mailto:support@yanzinetworks.com" }, { children: "support@yanzinetworks.com" }), void 0), "."] }, void 0),
            jsx_runtime_1.jsx(react_router_dom_1.Link, Object.assign({ to: '/' }, { children: "Go to start page" }), void 0)] }), void 0));
}
exports.ErrorNotFound = ErrorNotFound;
//# sourceMappingURL=index.js.map